const translations = {
    ariaLabelBlock: 'Block',
    ariaLabelOk: 'Ok',
    ariaLabelWarn: 'Warn'
};

export default translations;
